/* eslint-disable */
import { useState } from 'react';
import {
	ArrowLeft,
	ArrowRight,
	CheckCheck,
	ClipboardList,
	Package,
	X,
} from 'lucide-react';

export const BTN_ICONS = {
	check: CheckCheck,
	plan: ClipboardList,
	arrowLeft: ArrowLeft,
	arrowRight: ArrowRight,
};

export const SKU_TYPE_SHORT = {
	PRODUCT: 'FG',
	INTERMEDIATE: 'SFG',
	INGREDIENT: 'ING',
	UNPACKED_PRODUCT: 'U-FG',
	PACKAGING: 'PKG',
};

export const skuTypeShort = (type) =>
	SKU_TYPE_SHORT[String(type || '').toUpperCase()] || type || '';

export const SkuTypeChip = ({ type }) => (type ? (
	<span className='rounded border border-gray-200 bg-gray-100 px-1 py-[1px] text-[10px] font-semibold leading-none text-gray-500'>
		{skuTypeShort(type)}
	</span>
) : null);

export const ProductThumb = ({ src }) => {
	const [broken, setBroken] = useState(false);
	if (!src || broken) {
		return (
			<span className='flex h-7 w-7 flex-shrink-0 items-center justify-center rounded border border-gray-200 bg-gray-100'>
				<Package className='h-4 w-4 text-gray-400' />
			</span>
		);
	}
	return (
		<img
			src={src}
			alt=''
			onError={() => setBroken(true)}
			className='h-7 w-7 flex-shrink-0 rounded border border-gray-200 object-cover'
		/>
	);
};

// Dropdown menu item for the product pickers (Add Products / replacement):
// thumbnail + name, with the sku-type chip and sku code on a second line.
export const renderProductMenuItem = (label, item) => (
	<div className='flex items-center gap-2 leading-none'>
		<ProductThumb src={item?.imageUrl} />
		<div className='min-w-0 flex-1'>
			<p
				className='m-0 truncate text-[13px] leading-4 text-gray-800'
				title={item?.viewOnlyLabel}
			>
				{item?.viewOnlyLabel || label}
			</p>
			<div className='mt-1 flex items-center gap-1.5 leading-none'>
				<SkuTypeChip type={item?.skuType} />
				{item?.clientVariantId && (
					<span className='text-[11px] leading-3 text-gray-400'>
						{`SKU · ${item.clientVariantId}`}
					</span>
				)}
			</div>
		</div>
	</div>
);

export const renderHeaderCell = (column, { onRemoveColumn } = {}) => {
	// Pasted column that doesn't exist in the system — whole column is red,
	// with a cross to remove it.
	if (column?.unknown) {
		return (
			<div className='relative w-full rounded bg-red-100 px-1 py-0.5 pr-6 leading-tight'>
				<span
					className='block truncate text-[12px] font-semibold normal-case text-red-700'
					title={column?.title}
				>
					{column?.title}
				</span>
				<span className='text-[10px] font-medium normal-case text-red-500'>
					Not in system
				</span>
				{onRemoveColumn && (
					<button
						type='button'
						onClick={(e) => {
							e.stopPropagation();
							onRemoveColumn(column?.key);
						}}
						className='absolute right-1 top-1/2 -translate-y-1/2 rounded p-0.5 text-red-400 transition-colors hover:bg-red-200 hover:text-red-700'
						title='Remove this column'
					>
						<X className='h-3.5 w-3.5' />
					</button>
				)}
			</div>
		);
	}
	if (column?.shortName) {
		return (
			<div className='w-full leading-tight'>
				<span
					className='block truncate text-[12px] font-semibold normal-case text-gray-700'
					title={column?.storeName || column?.title}
				>
					{column?.storeName || column?.title}
				</span>
				<span className='text-[11px] font-bold normal-case text-amber-800'>
					{column.shortName}
				</span>
			</div>
		);
	}
	return (
		<span
			className='block w-full truncate text-[12px] font-semibold normal-case leading-tight text-gray-700'
			title={column?.title}
		>
			{column?.title}
		</span>
	);
};

export const CLOSED_CONFIRMATION = {
	isOpen: false,
	message: '',
	heading: '',
	isAlert: false,
	alertType: 'info',
	customButton: [],
	showCrossBtn: false,
	isLoading: false,
};
export const detailsLayoutConfig = (step) => ({
	containerClass: `${step?.card?.layout || 'grid grid-cols-1 sm:grid-cols-2 gap-4'} w-full bg-transparent gap-x-6 gap-y-6 [&_span.border-b]:!border [&_span.border-b]:!border-gray-300 [&_span.border-b]:!rounded-lg [&_span.border-b]:!h-10 [&_span.border-b]:!px-3 [&_span.border-b]:!flex [&_span.border-b]:!items-center [&_.rs-picker]:!w-full [&_.rs-picker-toggle-wrapper]:!w-full`,
	fieldWrapperClass: 'flex w-full min-w-0 max-w-none flex-col items-start gap-1.5',
	labelClass: 'm-0 w-full p-0 text-left text-[13px] font-semibold leading-[1.2] !text-gray-800 [&>span]:!text-red-500',
	inputClass: 'w-full [&_.rs-picker-toggle]:!h-10 [&_.rs-picker-toggle]:!py-2 [&_.rs-picker-toggle]:!px-3 [&_.rs-picker-toggle]:!text-[14px] [&_.rs-picker-toggle]:!rounded-lg [&_input]:!h-10 [&_input]:!py-2 [&_input]:!text-[14px] [&_input]:!rounded-lg',
	tabContainerClass: 'flex w-full flex-wrap gap-1.5',
	selectedTabClass: 'min-h-[40px] rounded-lg border-2 border-amber-400 bg-amber-50 px-4 py-2 text-[13px] font-semibold text-gray-900 shadow-sm',
	unselectedTabClass: 'min-h-[40px] rounded-lg border border-gray-200 bg-white px-4 py-2 text-[13px] font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700',
});
